var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLightningBolt = function SvgLightningBolt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00011 18H3.00011L4.00011 11H0.500114C-0.0798864 11 -0.0698865 10.68 0.120113 10.34C0.310113 10 0.170114 10.26 0.190114 10.22C1.48011 7.94 3.42011 4.54 6.00011 0H7.00011L6.00011 7H9.50011C9.99011 7 10.0601 7.33 9.97011 7.51L9.90011 7.66C5.96011 14.55 4.00011 18 4.00011 18Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLightningBolt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lightning-bolt.d63ed8f2570ec1b0c19c285681119d6c.svg";